import React from 'react';
import { Box, Typography, FormControlLabel, Checkbox, CircularProgress, Alert, FormGroup } from '@mui/material';
import { useShiftPatterns } from '../hooks';

interface ShiftPatternSelectProps {
  value: string[];
  onChange: (values: string[]) => void;
  label?: string;
  regionIds?: string[];
  depotIds?: string[];
  departmentIds?: string[];
  jobRoleIds?: string[];
}

export const ShiftPatternSelect: React.FC<ShiftPatternSelectProps> = ({
  value,
  onChange,
  label = 'Shift patterns',
  regionIds,
  depotIds,
  departmentIds,
  jobRoleIds,
}) => {
  const { data, isLoading, error } = useShiftPatterns({ regionIds, depotIds, departmentIds, jobRoleIds });

  const handleChange = (optionValue: string) => {
    if (value.includes(optionValue)) {
      onChange(value.filter((v) => v !== optionValue));
    } else {
      onChange([...value, optionValue]);
    }
  };

  if (error) {
    return <Alert severity='error'>Failed to load shift patterns. Please try again.</Alert>;
  }

  const options = data?.data || [];

  return (
    <Box>
      <Typography variant='subtitle2' gutterBottom color='text.secondary'>
        {label}
      </Typography>
      {isLoading ? (
        <Box display='flex' alignItems='center' gap={1}>
          <CircularProgress size={16} />
          <Typography variant='body2' color='text.secondary'>
            Loading shift patterns...
          </Typography>
        </Box>
      ) : (
        <FormGroup row>
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              control={<Checkbox checked={value.includes(option.value)} onChange={() => handleChange(option.value)} />}
              label={option.label}
            />
          ))}
        </FormGroup>
      )}
    </Box>
  );
};
